import { __read, __spreadArray } from "tslib";
import { EmptyTableInfoError } from '../../error/errors';
import TableOperationUtils from '../table-operation-utils';
function getPrimaryKeys(options, properties) {
    if (options === null || options === void 0 ? void 0 : options.key) {
        if (typeof options.key === 'string') {
            return [options.key];
        }
        return options.key;
    }
    var primaryKeys = properties
        .filter(function (prop) {
        return prop.isPrimaryKey;
    })
        .map(function (prop) { var _a; return (_a = prop.alias) !== null && _a !== void 0 ? _a : prop.name; });
    return primaryKeys.length > 0 ? primaryKeys : undefined;
}
function table(tableName, options) {
    return function (target) {
        var tableInfo = TableOperationUtils.getFirstTableInfoAlongPrototypeChain(target.prototype);
        if (!tableInfo) {
            throw new EmptyTableInfoError();
        }
        else {
            tableInfo.tableName = tableName;
        }
        var properties = __spreadArray([], __read(tableInfo.properties.values()));
        var primaryKeys = getPrimaryKeys(options, properties);
        tableInfo.keyPath = primaryKeys;
        tableInfo.autoIncrement = tableInfo.keyPath === undefined;
        TableOperationUtils.saveTableInfo(tableInfo, target.prototype);
    };
}
export default table;
//# sourceMappingURL=table.js.map